import { render, staticRenderFns } from "./ExamHeader.vue?vue&type=template&id=6b129a64&scoped=true"
import script from "./ExamHeader.vue?vue&type=script&lang=js"
export * from "./ExamHeader.vue?vue&type=script&lang=js"
import style0 from "./ExamHeader.vue?vue&type=style&index=0&id=6b129a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b129a64",
  null
  
)

export default component.exports